import { createReducer } from '@reduxjs/toolkit';

import * as DocumentPreviewActions from './actions';
import { Constants } from './constants';
import { IDocumentPreviewState } from './interfaces';

const initialDocumentPreviewState: IDocumentPreviewState = {
    document: undefined,
    documentsList: undefined,
    documentArtifacts: undefined,
    activeArtifact: undefined,
    activeFile: undefined,
    previewShown: undefined,
    messageLoading: false,
};

export const documentPreviewReducer = createReducer(initialDocumentPreviewState, {
    [Constants.DOCUMENT_PREVIEW_INITIATE]: (
        draftState,
        action: ReturnType<typeof DocumentPreviewActions.initiateDocumentPreview>
    ) => {
        const { activeArtifact, artifacts, document, activeFile } = action.payload;

        draftState.activeFile = activeFile;
        draftState.activeArtifact = activeArtifact;
        draftState.document = document;
        draftState.documentsList = [document];
        draftState.documentArtifacts = artifacts;
        draftState.previewShown = true;
    },

    [Constants.MESSAGE_LOADING]: (draftstate, action) => {
        draftstate.messageLoading = action.payload;
    },

    [Constants.DOCUMENT_PREVIEW_HIDE]: (draftState) => {
        draftState.previewShown = false;
    },

    [Constants.DOCUMENT_PREVIEW_CLEAR]: (draftState) => {
        draftState.document = null;
        draftState.documentArtifacts = null;
        draftState.activeArtifact = null;
        draftState.activeFile = null;
        draftState.previewShown = false;
    },

    [Constants.ARTIFACT_PREVIEW]: (draftState, action: ReturnType<typeof DocumentPreviewActions.previewArtifact>) => {
        const { artifact, file } = action.payload;

        draftState.activeArtifact = artifact;
        draftState.activeFile = file || artifact?.files?.[0];
    },

    [Constants.PREVIEW_DOCUMENT_UPDATE]: (
        draftState,
        action: ReturnType<typeof DocumentPreviewActions.updateDocumentForViewer>
    ) => {
        const { document } = action.payload;

        draftState.document = document;
        draftState.documentsList = [document];
    },
});
